<template>
  <div class="partner-registration-steps-navigation">
    <div class="partner-registration-steps-navigation__dashed-line"></div>
    <div
      v-for="(step, index) in steps"
      :key="step.title"
      class="partner-registration-steps-navigation__item"
    >
      <div
        :class="[
          'partner-registration-steps-navigation__number',
          {
            'partner-registration-steps-navigation__number--active':
              currentStep >= index + 1,
            'partner-registration-steps-navigation__number--inactive':
              currentStep < index + 1,
            'partner-registration-steps-navigation__number--clickable':
              currentStep > index + 1,
          },
        ]"
        @click="handleStepClick(index + 1)"
      >
        <span>{{ index + 1 }}</span>
      </div>
      <span
        :class="[
          'partner-registration-steps-navigation__title',
          {
            'partner-registration-steps-navigation__title--active':
              currentStep >= index + 1,
            'partner-registration-steps-navigation__title--inactive':
              currentStep < index + 1,
            'partner-registration-steps-navigation__title--clickable':
              currentStep > index + 1,
          },
        ]"
        @click="handleStepClick(index + 1)"
        >{{ step.title }}</span
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { usePartnerRegistration } from '~/composables/usePartnerRegistration'

const { t } = useI18n()
const { goToStep } = usePartnerRegistration()
const route = useRoute()

const steps = computed(() => [
  { title: t('partner.registration.form.steps.general') },
  { title: t('partner.registration.form.steps.business') },
  { title: t('partner.registration.form.steps.register') },
])

const currentStep = computed(() => {
  const stepMatch = route.path.match(/\/partner\/register\/(\d+)/)
  return stepMatch ? parseInt(stepMatch[1], 10) : 1
})

const handleStepClick = (step: number) => {
  if (step < currentStep.value) {
    goToStep(step)
  }
}
</script>

<style lang="postcss" scoped>
.partner-registration-steps-navigation {
  @apply flex items-center justify-between mb-8 relative;
}

.partner-registration-steps-navigation__dashed-line {
  @apply absolute top-1/2 left-0 right-0 flex-1 border-b border-dashed border-gray-400;
}

.partner-registration-steps-navigation__item {
  @apply flex items-center bg-white z-10;
  &:nth-child(1) {
    @apply pl-0 md:pl-4;
  }
  &:nth-child(2) {
    @apply pr-0 md:pr-4;
  }
  &:nth-child(3) {
    @apply pr-0 md:pr-4 pl-0 md:pl-4;
  }
  &:nth-child(4) {
    @apply pl-0 md:pl-4;
  }
}

.partner-registration-steps-navigation__number {
  @apply w-6 md:w-8 h-6 md:h-8 rounded-full flex items-center justify-center text-sm font-medium cursor-default;
}

.partner-registration-steps-navigation__number--active {
  @apply bg-teal-900 text-white;
}

.partner-registration-steps-navigation__number--inactive {
  @apply border border-gray-400 bg-white text-gray-400;
}

.partner-registration-steps-navigation__number--clickable {
  @apply cursor-pointer;
}

.partner-registration-steps-navigation__title {
  @apply ml-2 text-sm font-medium cursor-default;
}

.partner-registration-steps-navigation__title--active {
  @apply text-teal-900;
}

.partner-registration-steps-navigation__title--inactive {
  @apply text-gray-400;
}

.partner-registration-steps-navigation__title--clickable {
  @apply cursor-pointer;
}

.partner-registration-steps-navigation__connector {
  @apply flex items-center mx-4;
  height: 0px;
  flex: 1;
  border-bottom: 1px dashed;
  max-width: 120px;
}

.partner-registration-steps-navigation__connector--active {
  @apply border-gray-300;
}

.partner-registration-steps-navigation__connector--inactive {
  @apply border-gray-200;
}
</style>
